import React, { useEffect, useRef, useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";
import Modal from "../../../Modal";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Close } from "@mui/icons-material";

const GIFPicker = ({ handleClose, handleGifClick, gifPickerRef, type = "gifs" }) => {
  const giphyFetch = new GiphyFetch("mUZHhjVpp4j3RUpAFU00x4dAqyRhXU5T");
  // Giphy exposes the SAME endpoints for animated GIFs and transparent
  // "stickers" via a `type` param — chat reuses this one component for both
  // (ISP-9999). Default "gifs" keeps the Editor's existing behaviour untouched.
  const giphyType = type === "stickers" ? "stickers" : "gifs";
  const label = giphyType === "stickers" ? "Stickers" : "GIFs";

  const [searchTerm, setSearchTerm] = useState("");
  const [gifs, setGifs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);

  const loader = useRef(null);
  const offsetRef = useRef(offset); // Create a ref for the offset
  const searchTermRef = useRef(searchTerm);

  // const handleSearch = () => {
  //   if (searchTerm) {
  //     setLoading(true);
  //     setOffset(0);
  //     giphyFetch
  //       .search(searchTerm, { limit: 10 })
  //       .then((response) => {
  //         setGifs(response.data);
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching GIFs:", error);
  //         setLoading(false);
  //       });
  //   }
  // };

  const handleSearch = () => {
    if (searchTerm) {
      setLoading(true);
      setOffset(0); // Reset offset to 0 for a new search
      loadGifs(0); // Call loadGifs with offset 0 to start a new search
    }
  };

  useEffect(() => {
    offsetRef.current = offset;
  }, [offset]);

  useEffect(() => {
    searchTermRef.current = searchTerm;
  }, [searchTerm]);

  // const loadGifs = (newOffset) => {
  //   setLoading(true);

  //   const searchTermParam = !searchTerm ? {} : { q: searchTerm };

  //   !searchTerm
  //     ? giphyFetch
  //         .trending({ limit: 10, offset: newOffset, ...searchTermParam })
  //         .then((response) => {
  //           setGifs((prevGifs) =>
  //             newOffset === 0 ? response.data : [...prevGifs, ...response.data]
  //           );
  //           setLoading(false);
  //         })
  //         .catch((error) => {
  //           console.error("Error fetching GIFs:", error);
  //           setLoading(false);
  //         })
  //     : giphyFetch
  //         .search({ limit: 10, offset: newOffset, ...searchTermParam })
  //         .then((response) => {
  //           setGifs((prevGifs) =>
  //             newOffset === 0 ? response.data : [...prevGifs, ...response.data]
  //           );
  //           setLoading(false);
  //         })
  //         .catch((error) => {
  //           console.error("Error fetching GIFs:", error);
  //           setLoading(false);
  //         });
  // };

  console.log("cc", gifs);

  const loadGifs = (newOffset) => {
    setLoading(true);
    const currentSearchTerm = searchTermRef.current; // Use the ref's current value

    if (currentSearchTerm) {
      giphyFetch
        .search(currentSearchTerm, { limit: 10, offset: newOffset, type: giphyType })
        .then((response) => {
          setGifs((prevGifs) =>
            newOffset === 0 ? response.data : [...prevGifs, ...response.data]
          );
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching GIFs:", error);
          setLoading(false);
        });
    } else {
      giphyFetch
        .trending({ limit: 10, offset: newOffset, type: giphyType })
        .then((response) => {
          setGifs((prevGifs) =>
            newOffset === 0 ? response.data : [...prevGifs, ...response.data]
          );
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching GIFs:", error);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    loadGifs(0);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    });
    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [loader.current]);

  const handleObserver = (entities) => {
    const target = entities[0];

    if (target.isIntersecting) {
      const currentOffset = offsetRef.current; // Use the ref's current value instead of the state variable
      setOffset(currentOffset + 10);
      loadGifs(currentOffset + 10); // Pass the updated offset to loadGifs
    }
  };

  return (
    <div>
      <Box
        style={{
          position: "fixed",
          padding: "5px 16px 60px 10px",
          width: "278px",
          borderRadius: "5px",
          border: "1px solid #e8e8e8",
          boxShadow: "0px 0px 9.3px 0px rgba(59, 59, 59, 0.21)",
          top: "60vh",
          left: "27vw",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#FFF",
          gap: "10px",
          minHeight: "367px",
          maxHeight: "fit-content",
          boxSizing: "border-box",
          outline: "none",
        }}
        ref={gifPickerRef}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            onClick={handleClose}
            style={{
              borderRadius: "12.5px",
              cursor: "pointer",
              position: "absolute",
              right: 15,
              // top: "-75px",
              height: "10px",
              width: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 90,
            }}
          >
            <Close
              style={{
                color: "#123051",
              }}
            />
          </Box>
        </div>

        <div>
          <Box sx={{ ml: "10px", fontSize: "10px", color: "#00000099" }}>
            {label}
          </Box>
          <TextField
            autoComplete
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
            placeholder={`Search for ${label}`}
            sx={{
              bgcolor: "#ffffff",
              width: "226px",
              borderRadius: "20px", // Ensures the border radius is applied to the input field
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px", // Ensures the border radius is applied to the input field
                height: "40px",
                fontSize: "11px",
              },
              "& .MuiInputBase-input": {
                // Targeting the input element for padding
                marginLeft: "-12px", // Adjust this value for your desired padding
              },
            }}
            InputProps={{
              // Changed from endAdornment to startAdornment
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    sx={{ marginLeft: "-10px" }}
                    onClick={handleSearch}
                  >
                    <SearchIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        {/* <Autocomplete
          freeSolo
          value={searchTerm}
          onInputChange={handleSearch}
          options={searchHistory}
          renderInput={(params) => (
            <TextField {...params} label="Search for GIFs" fullWidth />
          )}
        /> */}

        <Box height="265px" overflow="auto" sx={{ mt: 2 }}>
          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress size={48} style={{ color: "#123051" }} />
            </div>
          )}
          <Grid container spacing={0.25}>
            {gifs.map((gif) => (
              <Grid
                item
                xs={4}
                key={gif.id}
                onClick={() => handleGifClick(gif)}
              >
                <img
                  src={gif.images.fixed_height.url}
                  alt={gif.title}
                  style={{
                    width: "75px",
                    height: "75px",
                    cursor: "pointer",
                    objectFit: "cover",
                  }}
                />
              </Grid>
            ))}
          </Grid>
          <div ref={loader} />
        </Box>
      </Box>
    </div>
  );
};

export default GIFPicker;
